import I18n from "../../../../../core/localization/I18n";

interface NoDataFoundProps {
  onBack: any;
}

export const NoDataFound: React.FC<ReactProps & NoDataFoundProps> = ({ onBack }) => {
  return (
    <div className="container-fluid no-data-message">
      <h3>{I18n.t("phrases.noDataFound")}</h3>
      <p>{I18n.t("phrases.pleaseGoBack")}</p>
      <button className="navigation-button back-button" onClick={onBack || null}>
        {I18n.t("phrases.back")}
      </button>
    </div>
  );
};
